import React, { useState } from 'react';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Search as SearchIcon } from 'lucide-react';
import SearchResults from '@/components/SearchResults';
import Navbar from '@/components/Navbar';
import { searchVideos } from '@/lib/youtubeApi';
import { useQuery } from '@tanstack/react-query';
import { getCollections, addVideoToCollection } from '@/lib/supabase';
import { useAuth } from '@/contexts/AuthContext';
import type { VideoItem } from '@/lib/supabase';

const Search = () => {
  const { user } = useAuth();
  const [searchQuery, setSearchQuery] = useState<string>('');
  const [isSearching, setIsSearching] = useState<boolean>(false);
  const [searchResults, setSearchResults] = useState([]);

  const { data: collections = [] } = useQuery({
    queryKey: ['collections'],
    queryFn: getCollections,
    enabled: !!user
  });

  const handleSearch = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!searchQuery.trim()) return;
    
    setIsSearching(true);
    const results = await searchVideos(searchQuery);
    setSearchResults(results);
    setIsSearching(false);
  };

  const handleAddVideo = async (video: VideoItem, collectionId: string) => {
    try {
      await addVideoToCollection(collectionId, video);
      console.log(`Video "${video.title}" added to collection ${collectionId}`);
    } catch (error) {
      console.error("Error adding video:", error);
    }
  };

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <main className="container mx-auto px-4 py-8">
        <div className="max-w-3xl mx-auto mb-8">
          <form onSubmit={handleSearch} className="flex gap-2">
            <Input
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search for YouTube videos..."
              className="flex-1"
            />
            <Button type="submit" disabled={isSearching}>
              <SearchIcon size={16} className="mr-2" />
              Search
            </Button>
          </form>
        </div>

        <SearchResults 
          results={searchResults}
          collections={collections}
          isLoading={isSearching}
          onAddVideo={handleAddVideo}
        />
      </main>
    </div>
  );
};

export default Search;